import Vue from 'vue'
import Vuex from 'vuex'
import user from '@/api/sys/user'

Vue.use(Vuex)

/**
 * 数据池
 * @type {{}}
 */
const state = {
  menuItems: [],
  roles:[],
  isCollapse: false,
  isRefresh: false,
  drivingMain: false,//自动主图
  drivingOther: false,//自动三张图
  token: "",//自动三张图
}

/**
 * 更改state中数据的方法
 * @type {{}}
 */
const mutations = {
  initMenuItems(state, data) {
    state.menuItems = data;
  },
  initToken(state, data) {
    state.token = data;
  },
  initRoles(state, data) {
    state.roles = data;
  },
}
/**
 * 通知mutations更改数据的方法
 * @type {{}}
 */
const actions = {
  initMenuItems({commit}, data) {
    commit('initMenuItems', data)
  },
  initToken({commit}, data) {
    commit('initToken', data)
  },
  initRoles({commit}, data) {
    commit('initRoles', data)
  },
  // get user info
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      user.userLoginDetails().then(response => {
        const { data } = response.data
        if (!data) {
          reject('Verification failed, please Login again.')
        }
        commit('initMenuItems', data.menuData)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
}

export default new Vuex.Store({
  state,  //状态对象，相当于一个数据池data
  mutations, // 包含多个更新state函数的对象
  actions, //包含多个对应事件回调函数的对象
})




// WEBPACK FOOTER //
// ./src/store/index.js